"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.VinRecallLookup = void 0;
var _vinRecallLookup = _interopRequireDefault(require("./components/vin-recall-lookup"));
exports.VinRecallLookup = _vinRecallLookup["default"];